import { Injectable } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { BehaviorSubject, ReplaySubject, startWith, Subject, tap } from 'rxjs';

export type PremjestajData = {
  $redoslijed: number | null;
};

@Injectable({ providedIn: 'root' })
export class PremjestiService {
  private _premjestajData = new ReplaySubject<PremjestajData>(1);

  private _premjestajSubject = new BehaviorSubject<boolean>(false);

  private _rootData = new Subject<TreeNode>();

  public premjestajData$ = this._premjestajData.asObservable();

  private redoslijedChangeSubject = new Subject<number>();

  public premjestajDialogVisible$ = this._premjestajSubject
    .asObservable()
    .pipe(tap((bisible) => console.log(bisible)));

  public rootSelected$ = this._rootData.asObservable().pipe(startWith({}));

  public redoslijedChange$ = this.redoslijedChangeSubject.asObservable();

  private loadingSubject = new BehaviorSubject(true);
  public loading$ = this.loadingSubject.asObservable();

  batchMode$ = new BehaviorSubject<boolean>(false);
  batchCount$ = new BehaviorSubject<number>(0);

  openPremjestanjeDialog(visible: boolean) {
    this._premjestajSubject.next(visible);
    if (visible == false) {
      this._premjestajData.next({ $redoslijed: null });
      this.batchMode$.next(false);
      this.batchCount$.next(0);
    }
  }

  setBatchMode(count: number) {
    this.batchMode$.next(true);
    this.batchCount$.next(count);
  }

  premjestanjeConfigComplete(data: PremjestajData) {
    this._premjestajData.next(data);
  }

  rootSelected(node: TreeNode) {
    this._rootData.next(node);
  }

  changeRedoslijed(redoslijed: number) {
    this.redoslijedChangeSubject.next(redoslijed);
    this.loadingSubject.next(true);
  }

  loadingFinished() {
    this.loadingSubject.next(false);
  }
}
